import GlossaryItem from './GlossaryItem/GlossaryItem';

const React = require('react');
const HtmlToReact = require('html-to-react');
const HtmlToReactParser = require('html-to-react').Parser;
const { HashLink } = require('react-router-hash-link');

const isNested = (node, depth = 0) => {
  if (node && depth < 4) {
    const { parent } = node;
    return (
      (parent && parent.attribs['data-glossary-id']) ||
      isNested(parent, depth + 1)
    );
  }
  return false;
};

// TODO: All of this functionality should be moved to the server within the short code function on WordPress
export const stripPTags = content => {
  let contentReplacement;
  if (typeof content !== 'undefined') {
    contentReplacement = content.replace(new RegExp('p>', 'g'), 'div>');
    contentReplacement = contentReplacement.replace(
      new RegExp('p class="CHNbody">', 'g'),
      'div>'
    ); // Account for some of the content the client is copying and pasting.
    contentReplacement = contentReplacement.replace(
      new RegExp('div>', 'g'),
      'div class="content-formatted">'
    );
    contentReplacement = contentReplacement.replace(
      new RegExp('>="glossary-item">', 'g'),
      '>'
    );
    contentReplacement = contentReplacement.replace(new RegExp('<<', 'g'), '<');
  }

  return contentReplacement;
};

/**
 * Format Content for React
 * ========================
 *
 * Container function to convert WordPress content for React front-end
 *
 * 1. Convert HTML anchors to React hash links
 * ----------------------------------------
 * Anchor reference links are returned returned from WordPress are standard HTML.
 * This works in some browsers (Chrome), but not on Safari or iOS.
 * Need to convert these anchors to React HashLinks to work everywhere.
 *
 * Before: <a href="#930" data-reference-id="930">1</a>
 * After: <HashLink to={`#930`}>1</HashLink>
 */
export const formatContentForReact = content => {
  // TODO: temp solution until stripPTags WP shortcode solution
  const htmlInput = stripPTags(content);

  const isValidNode = () => true;

  const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);

  // offset anchors to account for the fixed header (large screens only)
  // TODO: dupe with src/containers/App.js
  const headerHeightOffset = window.innerWidth < 1024 ? 0 : -136;

  // order matters, instructions processed in the order they're defined
  // @see https://www.npmjs.com/package/html-to-react
  // @see https://github.com/aknuds1/html-to-react
  const processingInstructions = [
    {
      replaceChildren: false,
      shouldProcessNode(node) {
        return node.attribs && node.attribs['data-reference-id'];
      },
      processNode(node, children, index) {
        return (
          <HashLink
            key={index}
            to={node.attribs.href}
            className="reference-link"
            data-reference-id={node.attribs['data-reference-id']}
            scroll={el => {
              el.scrollIntoView({ behavior: 'instant', block: 'start' });
              window.scrollBy(0, headerHeightOffset);
            }}
          >
            {node.children[0].data}
          </HashLink>
        );
      }
    },
    {
      shouldProcessNode(node) {
        return node.attribs && node.attribs['data-glossary-id'];
      },
      processNode(node, children) {
        if (isNested(node)) {
          return (
            <a href={`/glossary#${children[1].props.children.toLowerCase().replace(' ', '-')}`}>
              {children[0]}
            </a>
          );
        }
        return (
          children[0] &&
          children[1] &&
          children[2] && (
            <GlossaryItem
              anchor={children[0]}
              title={children[1]}
              content={children[2]}
            />
          )
        );
      }
    },
    {
      // anything else
      shouldProcessNode() {
        return true;
      },
      processNode: processNodeDefinitions.processDefaultNode
    }
  ];

  const htmlToReactParser = new HtmlToReactParser();
  const reactComponent = htmlToReactParser.parseWithInstructions(
    htmlInput,
    isValidNode,
    processingInstructions
  );
  // const reactHtml = ReactDOMServer.renderToStaticMarkup(reactComponent);

  return reactComponent;
};



// WEBPACK FOOTER //
// ./src/components/globalHelpers.js